import pointListForUIMaker from '@/vuex/modules/pointGroupOperation/gettersUtil/pointListForUI'
import targetGroupMaker from '@/vuex/modules/pointGroupOperation/gettersUtil/targetGroupMaker'
import isUpdate from './actionsUtil/isUpdate'
import {
  locationGroupType,
  locationFilter,
} from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

const getters = {
  groupList: state => {
    return state.groupList
  },
  targetGroup: state => {
    const initialTargetGroup = state.editMode.initialTargetGroup
    const currentTargetGroup = state.editMode.currentTargetGroup
    return targetGroupMaker({ initialTargetGroup, currentTargetGroup })
  },
  loadingPointList: state => {
    return state.editMode.loadingPointList
  },
  initialPointList: state => {
    return state.editMode.initialPointList
  },
  currentPointList: state => {
    return state.editMode.currentPointList
  },
  isEditingPoiCategory: state => {
    return state.editMode.isEditingPoiCategory
  },
  pointListForUI: state => {
    const currentPointList = state.editMode.currentPointList
    const initialPointList = state.editMode.initialPointList
    const res = pointListForUIMaker(currentPointList, initialPointList)
    return res
  },
  selectedPoint: state => {
    return state.editMode.selectedPoint
  },
  mapCenter: state => {
    return state.editMode.mapCenter
  },
  newItemId: state => {
    return state.editMode.newItemId
  },
  pagePermission: state => {
    const pagePermission = state.editMode.pagePermission
    switch (pagePermission) {
      case 'admin':
      case 'operator': {
        return 'edit'
      }
      case 'readonly':
      case 'view': {
        return 'view'
      }
      default: {
        return 'none'
      }
    }
  },
  locationFilter: state => {
    return state.locationFilter
  },
  lastDragEndTime: state => {
    return state.editMode.lastDragEndTime
  },
  targetGroupHasUpdates: (state, getters) => {
    if (!getters.targetGroup) return false
    const { targetGroup, pointListForUI } = getters
    return isUpdate({ pointListForUI, targetGroup })
  },
  filteredPointList: (state, getters) => pointList => {
    // カテゴリーグループは、statusを持たないのでフィルターを常にallにする
    const locationFilterState =
      getters.targetGroup.locationType === locationGroupType.POI_LOCATION
        ? locationFilter.ALL
        : getters.locationFilter
    switch (locationFilterState) {
      case locationFilter.ALL:
        return pointList
      default:
        return pointList.filter(
          point => point.status === locationFilterState || point.updated,
        )
    }
  },
  map: state => {
    return state.map
  },
  mapLoaded: state => {
    return state.mapLoaded
  },
  pointListInFrameCount: state => {
    return state.pointListInFrameCount
  },
  searchQuery: state => {
    return state.editMode.search.query
  },
  searchResultList: state => {
    return state.editMode.search.resultList
  },
  currentSearchResultIndex: state => {
    return state.editMode.search.currentResultIndex
  },
  fitBounds: state => {
    return state.fitBounds
  },
}

export default getters
